import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/services/shared.service';
import { AdministrationService } from 'src/app/services/administration.service';
import { MatSnackBar, MatDialogRef, MatDialog, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { EventClass, EventRank } from 'src/app/models/eventsDto';
import { ProgressSpinnerDialogComponent } from 'src/app/progress-spinner-dialog/progress-spinner-dialog.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PaginationResult } from 'src/app/models/shared-models';

@Component({
  selector: 'app-events-class',
  templateUrl: './events-class.component.html',
  styleUrls: ['./events-class.component.scss']
})
export class EventsClassComponent implements OnInit {

  eventId: number;
  id: number;

  form: FormGroup;
  dialogRef: MatDialogRef<ProgressSpinnerDialogComponent>;
  event: EventClass;
  userRole: string;
  ranks: EventRank[];

  constructor(
    private fb: FormBuilder,
    private sharedService: SharedService,
    private adminService: AdministrationService,
    private snackBar: MatSnackBar, private router: Router, private route: ActivatedRoute,
    private dialog: MatDialog, private authService: AuthenticationService) { }

  ngOnInit() {
    this.id = +this.route.snapshot.paramMap.get('id').toString();
    this.eventId = +this.route.snapshot.paramMap.get('eventId').toString();
    this.userRole = this.authService.getUserRole();
    this.buildForm();
    this.sharedService.GetRanksByEventId(this.eventId).subscribe((result: PaginationResult<EventRank[]>) => {
      this.ranks = result.data;
    }, error => {
      this.dialogRef.close();
    });

    if (this.id > 0){
      this.dialogRef = this.dialog.open(ProgressSpinnerDialogComponent, {
        panelClass: 'transparent',
        disableClose: true
      });
      this.adminService.GetEventClassById(this.id).subscribe((result: EventClass) => {
        this.dialogRef.close();
        this.event = result;
        this.updateForm();
      }, error => {
        this.dialogRef.close();
      });


    }

  }

  buildForm() {
    this.form = this.fb.group({
      eventId: new FormControl(this.eventId),
      classNo: new FormControl('', [Validators.required]),
      id: new FormControl(this.id),
      description: new FormControl('', [Validators.required]),
      rankId: new FormControl(0, [Validators.required])
    });
  }

  updateForm() {
    this.form.setValue({
      id: this.id,
      eventId: this.eventId,
      classNo: this.event.classNo,
      description: this.event.description,
      rankId: this.event.rankId
    });
  }

  onBackClick() {
    this.router.navigate(['/events/'+ this.eventId]);
  }

  onSubmit() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.AddOrUpdateEventClass(this.form.value).subscribe(res => {
      this.onBackClick();
      dialogRef.close();
      this.snackBar.open(this.eventId === -1 ? 'event created.' : 'event updated.', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open(this.eventId === -1 ? 'Error creating event.' : 'Error updating event.', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }

  onDelete() {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    this.adminService.RemoveEvent(this.eventId).subscribe(res => {
      dialogRef.close();
      this.router.navigate(['/events/'], { relativeTo: this.route });
      this.snackBar.open('Member Deleted', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
    }, error => {
      dialogRef.close();
      this.snackBar.open('Error deleting member', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }



}
